import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    // Skip auth header for public (no-auth) endpoints
    if (req.url.includes('/public/')) {
        return next(req);
    }

    const token = authService.getAccessToken();
    let authReq = req;

    if (token) {
        authReq = authReq.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    // ── Removed: x-user-email header (not required by backend) ──────────
    // const user = authService.getCurrentUser();
    // if (user?.email) {
    //     authReq = authReq.clone({
    //         setHeaders: { 'x-user-email': user.email }
    //     });
    // }

    return next(authReq);
};
